// extracted by mini-css-extract-plugin
export default {"errorIcon":"errors_errorIcon__BPRnE"};